// Built-in incoming-call ringtones, generated with the Web Audio API (no audio files).
// Each preset = two blended oscillators + an on/off cadence in [on, ms] segments.
export const RINGTONES = [
  { id: "classic", name: "Classic", type: "sine", freqs: [480, 620],
    segments: [[true, 400], [false, 200], [true, 400], [false, 1800]] },
  { id: "chime", name: "Chime", type: "sine", freqs: [660, 880],
    segments: [[true, 240], [false, 120], [true, 240], [false, 1600]] },
  { id: "pulse", name: "Pulse", type: "triangle", freqs: [520, 700],
    segments: [[true, 170], [false, 110], [true, 170], [false, 110], [true, 170], [false, 1500]] },
  { id: "warm", name: "Warm", type: "sine", freqs: [340, 430],
    segments: [[true, 620], [false, 300], [true, 620], [false, 1700]] },
  { id: "marimba", name: "Marimba", type: "triangle", freqs: [587, 784],
    segments: [[true, 130], [false, 70], [true, 130], [false, 70], [true, 130], [false, 1600]] },
];

const KEY = "pula_ringtone";

export function getRingtoneId() {
  try { return localStorage.getItem(KEY) || "classic"; } catch { return "classic"; }
}

export function getRingtone() {
  const id = getRingtoneId();
  return RINGTONES.find((r) => r.id === id) || RINGTONES[0];
}

export function setRingtoneId(id) {
  try { localStorage.setItem(KEY, id); } catch { /* ignore */ }
}

// Loops the member's chosen ringtone until stop() is called — used for incoming group calls.
export function playIncomingRing() {
  return previewRingtone(getRingtoneId(), 999);
}

// Play a preset once (used for the settings preview). Returns a stop() function.
export function previewRingtone(id, cycles = 1) {
  const tone = RINGTONES.find((r) => r.id === id) || RINGTONES[0];
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return () => {};
    const ctx = new Ctx();
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    const gain = ctx.createGain();
    gain.gain.value = 0;
    gain.connect(ctx.destination);
    const o1 = ctx.createOscillator(); o1.type = tone.type; o1.frequency.value = tone.freqs[0]; o1.connect(gain); o1.start();
    const o2 = ctx.createOscillator(); o2.type = tone.type; o2.frequency.value = tone.freqs[1]; o2.connect(gain); o2.start();
    let i = 0;
    const total = tone.segments.length * cycles;
    let timer = null;
    const stop = () => { if (timer) clearTimeout(timer); try { o1.stop(); o2.stop(); ctx.close(); } catch { /* ignore */ } };
    const run = () => {
      if (i >= total) { stop(); return; }
      const [on, ms] = tone.segments[i % tone.segments.length];
      gain.gain.setTargetAtTime(on ? 0.18 : 0, ctx.currentTime, 0.015);
      i += 1;
      timer = setTimeout(run, ms);
    };
    run();
    return stop;
  } catch { return () => {}; }
}
